if (!customElements.get('pfd-collection')) {
  customElements.define('pfd-collection', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const filters = this.querySelector('[data-shop-filter-panel]');
      const desktop = window.matchMedia('(min-width: 990px)');
      const syncFilters = () => { if (filters) filters.open = desktop.matches; };
      syncFilters();
      desktop.addEventListener('change', syncFilters, { signal });
      this.querySelector('[data-shop-sort]')?.addEventListener('change', (event) => {
        event.target.form?.requestSubmit();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
